import { jsxs, jsx } from "react/jsx-runtime";
const ProfileViewIcon = (props) => /* @__PURE__ */ jsxs("svg", { ...props, viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ jsx("path", { d: "M224 896C228.4 896 232 892.4 232 888L232 136C232 131.6 228.4 128 224 128H168C163.6 128 160 131.6 160 136L160 888C160 892.4 163.6 896 168 896H224Z" }),
  /* @__PURE__ */ jsx("path", { d: "M312 712V768C312 772.4 315.6 776 320 776H464C468.4 776 472 772.4 472 768V712C472 707.6 468.4 704 464 704H320C315.6 704 312 707.6 312 712Z" }),
  /* @__PURE__ */ jsx("path", { d: "M312 560V616C312 620.4 315.6 624 320 624H640C644.4 624 648 620.4 648 616V560C648 555.6 644.4 552 640 552H320C315.6 552 312 555.6 312 560Z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M312 408L312 464C312 468.4 315.6 472 320 472L562 472C566.4 472 570 468.4 570 464V408C570 403.6 566.4 400 562 400L320 400C315.6 400 312 403.6 312 408Z",
      fill: "black"
    }
  ),
  /* @__PURE__ */ jsx("path", { d: "M312 256V312C312 316.4 315.6 320 320 320L720 320C724.4 320 728 316.4 728 312V256C728 251.6 724.4 248 720 248L320 248C315.6 248 312 251.6 312 256Z" }),
  /* @__PURE__ */ jsx("path", { d: "M856 896C860.4 896 864 892.4 864 888V136C864 131.6 860.4 128 856 128H800C795.6 128 792 131.6 792 136V888C792 892.4 795.6 896 800 896H856Z" })
] });
export {
  ProfileViewIcon
};
